import React from 'react';

import css from './Form.module.scss';

interface Props {
    children: React.ReactNode;
}

const Form: React.FC<Props & React.HTMLProps<HTMLFormElement>> = ({ children, ...props }) => (
    <form className={css.form} {...props}>
        {children}
    </form>
);

export default React.memo(Form);
